module.exports = __webpack_public_path__ + "static/media/atar-career-journey-2.9df3b31c.jpg";